module.exports = __webpack_public_path__ + "img/tile-view.45354014.svg";